export default __webpack_public_path__ + "static/media/diffs-image.fddc0022.png";